import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.find-index";
import "core-js/modules/es6.function.name";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.regexp.split";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import NiotaClassicApiService from '../../../services/niotaClassicApiService';
import ApiService from '../../../services/apiService';
import { mapState } from 'vuex';
import get from 'lodash/get';
import isEqual from 'lodash/isEqual';
export default {
  name: 'NiotaClassicCommonAccountFilter',
  props: {
    iconOnly: {
      type: Boolean,
      required: false,
      default: false
    },
    initiallySelected: {
      type: Array,
      required: false,
      default: function _default() {
        return [];
      }
    },
    multiple: {
      type: Boolean,
      required: false,
      default: false
    },
    n1Accounts: {
      type: Boolean,
      required: false,
      default: false
    },
    showResetButton: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data: function data() {
    return {
      accounts: [],
      accountsSearchQuery: null,
      selectedAccounts: []
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions'])), {}, {
    singleButton: function singleButton() {
      return this.iconOnly && !this.showResetButton;
    },
    accountsQueryResult: function accountsQueryResult() {
      var _this = this;

      if (this.accountsSearchQuery) {
        var filtered = this.accounts.filter(function (item) {
          return _this.accountsSearchQuery.toLowerCase().split(' ').every(function (v) {
            return item.name.toLowerCase().includes(v);
          });
        });
        return this.selectedAccounts.filter(function (item) {
          return filtered.findIndex(function (fAcc) {
            return fAcc.id === item.id;
          }) < 0;
        }).concat(filtered);
      } else {
        return this.accounts;
      }
    },
    listSelection: function listSelection() {
      if (this.multiple) {
        return this.accountIndizes;
      }

      return get(this.accountIndizes, '[0]');
    },
    accountIndizes: function accountIndizes() {
      var _this2 = this;

      return this.accountsQueryResult.map(function (account, index) {
        if (_this2.selectedAccounts.findIndex(function (a) {
          return a.id === account.id;
        }) >= 0) {
          return index;
        }

        return null;
      }).filter(function (a) {
        return a !== null;
      });
    },
    accountId: function accountId() {
      return get(this.selectedAccounts, '[0].id');
    }
  }),
  watch: {
    initiallySelected: function initiallySelected() {
      this.initSelection();
    }
  },
  mounted: function mounted() {
    this.fetchAccountPlain();
  },
  methods: {
    fetchAccountPlain: function fetchAccountPlain() {
      var _this3 = this;

      var promise = null;

      if (this.n1Accounts) {
        promise = NiotaClassicApiService.accountsFetchPlain().then(function (response) {
          _this3.accounts = response.data.accounts;

          _this3.initSelection();

          _this3.$emit('accounts-loaded');
        });
      } else {
        promise = ApiService.tenantFetchAll().then(function (res) {
          _this3.accounts = res.tenants;

          _this3.initSelection();

          _this3.$emit('accounts-loaded');
        });
      }

      promise.catch(function (error) {
        _this3.$snack(_this3.$i18n_t('NiotaClassic.Devices.snacks.errorFindingAccounts'), 'error');

        _this3.$emit('accounts-loaded');

        console.error(error);
      });
    },
    initSelection: function initSelection() {
      var _this4 = this;

      if (this.initiallySelected.length && this.accounts.length) {
        var selectedAccounts = [];
        this.accounts.map(function (item) {
          if (_this4.initiallySelected.includes(item.id)) {
            item.selected = true;
            selectedAccounts.push(item);
          }
        }); // do not cause an endless loop here if `initiallySelected` is updated on the embedding component

        if (!isEqual(this.selectedAccounts, selectedAccounts)) {
          this.selectedAccounts = selectedAccounts;
          this.$emit('selected', this.selectedAccounts);
        }
      }
    },
    clickedAccount: function clickedAccount(idx, account) {
      // if the current account is not yet in the indizes-list it was obviously just selected
      var didSelect = this.accountIndizes.indexOf(idx) < 0;
      this.clickedAccountCheckbox(didSelect, account);
    },
    clickedAccountCheckbox: function clickedAccountCheckbox(event, account) {
      if (!this.multiple && this.accountIndizes.length > 0) {
        this.selectedAccounts = [];
      }

      account.selected = event;

      if (event) {
        this.selectedAccounts.push(account);
      } else {
        this.selectedAccounts.splice(this.selectedAccounts.findIndex(function (selectedAccount) {
          return selectedAccount.id === account.id;
        }), 1);
      }

      this.$emit('selected', this.selectedAccounts);
    }
  }
};